import { useCallback, useEffect, useState } from "react";
import { storage } from "@/lib/storage";
import { dayNumber } from "@/lib/daily";
import { trackEvent } from "@/lib/analytics";

const KEY = "atlas.diary";
const DONE_KEY = "atlas.diary.completed";
const EVENT = "atlas:diary";
const read = (k) => { const v = storage.getJSON(k, {}); return v && typeof v === "object" ? v : {}; };

/** Travel diary: visited stops per country { CODE: { "Stop EN name": dayNumber } } + completed trips { CODE: dayNumber }. */
export function useDiary(code) {
  const [visited, setVisited] = useState(() => read(KEY)[code] || {});
  const [completed, setCompleted] = useState(() => read(DONE_KEY));
  useEffect(() => {
    const sync = () => { setVisited(read(KEY)[code] || {}); setCompleted(read(DONE_KEY)); };
    sync();
    window.addEventListener(EVENT, sync); window.addEventListener("storage", sync);
    return () => { window.removeEventListener(EVENT, sync); window.removeEventListener("storage", sync); };
  }, [code]);

  const toggle = useCallback((stopId) => {
    const all = read(KEY); const mine = { ...(all[code] || {}) };
    if (mine[stopId]) delete mine[stopId]; else { mine[stopId] = dayNumber(); trackEvent("diary_visit", { code }); }
    storage.setJSON(KEY, { ...all, [code]: mine });
    window.dispatchEvent(new Event(EVENT));
  }, [code]);

  /** Marks the trip complete once; returns true the first time. */
  const complete = useCallback(() => {
    const all = read(DONE_KEY);
    if (all[code]) return false;
    storage.setJSON(DONE_KEY, { ...all, [code]: dayNumber() });
    window.dispatchEvent(new Event(EVENT));
    trackEvent("diary_complete", { code });
    return true;
  }, [code]);

  return { visited, completed, toggle, complete };
}

export const useCompletedTrips = () => {
  const [completed, setCompleted] = useState(() => read(DONE_KEY));
  useEffect(() => {
    const sync = () => setCompleted(read(DONE_KEY));
    window.addEventListener(EVENT, sync); window.addEventListener("storage", sync);
    return () => { window.removeEventListener(EVENT, sync); window.removeEventListener("storage", sync); };
  }, []);
  return completed;
};
